<template>
  <div class="Square">
    <div
      class="Square__Pic cursor-pointer bg-white rounded-md"
      @click.stop.prevent="select()"
    >
      <img
        class="rounded-md pointer-events-none select-none object-cover"
        :class="{'border-2 border-bc-blue': isSelected}"
        :src="item.previews['500x500']"
        alt=""
        style="aspect-ratio: 1;"
        @contextmenu.prevent.stop
      />
    </div>
    <div 
      class="Square__Text leading-tight py-1 text-sm text-gray-500 truncate max-w-full"
      @click.stop.prevent="select()"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'

export default {
  mixins: [
  ],
  props: ['item'],
  computed: {
    ...mapStores(useBcSelectedStore),
    isSelected() {
      return this.$formValues['frm-editForm-editForm-image__file_id'] === this.item.id
    }
  },
  methods: {
    select() {
      this.$formValues['frm-editForm-editForm-image__file_id'] = this.item.id
      this.$formValues['frm-editForm-editForm-icon_text'] = null
      this.$formValues['frm-editForm-editForm-icon_bg_color'] = null
      this.$store.commit('nette/updateControl', {
        controlName: 'frm-editForm-editForm-image__file_id',
        data: this.item,
        key: 'file',
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
